import stableHash from "common/utils/stableHash";
import { v5 as uuidv5 } from "uuid";

// Returns a stable UUID for any input
export default function stableUUID(input: unknown): string {
  return uuidv5(stableHash(input), uuidv5.URL);
}
